/**
 * Shown above a desktop page that a phone fell back to. Slim, non-blocking and
 * in flow — it never covers content and it never blocks the screen.
 */
export function NotPhoneOptimisedNotice() {
  return (
    <div
      role="status"
      className="type-caption w-full border-b border-border bg-muted px-sm py-xs text-muted-foreground"
    >
      This screen is not phone-optimized yet.
    </div>
  );
}
